export default __webpack_public_path__ + "static/media/favicon.95e5ae4b.ico";